import { render } from "./Wz2Details.vue?vue&type=template&id=5d73fb60&scoped=true"
import script from "./Wz2Details.vue?vue&type=script&lang=js"
export * from "./Wz2Details.vue?vue&type=script&lang=js"

import "./Wz2Details.vue?vue&type=style&index=0&id=5d73fb60&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d73fb60"]])

export default __exports__